import { ReactComponent as IcActivatedStatusBar } from '@assets/components/panel/sensors/ActivatedStatusBar.svg';
import { ReactComponent as IcActivatedStatusBarHigh } from '@assets/components/panel/sensors/ActivatedStatusBarHigh.svg';
import { ReactComponent as IcStatusBar } from '@assets/components/panel/sensors/StatusBar.svg';
import { ReactComponent as IcStatusBarHigh } from '@assets/components/panel/sensors/StatusBarHigh.svg';
import { Icon } from '@chakra-ui/react';
import { SensorOrSubSensorInfo } from '@components/cockpit/panels/monitoring/monitoring.types';
import { ColorLabelEnum, hexColor } from '@utils/map/map.constants';
import { getSensorHexColor } from '@utils/sensors/sensors.utils';

interface Props {
  activated: boolean;
  size?: 'md' | 'lg';
  sensorOrSubSensorInfo?: SensorOrSubSensorInfo;
}

export default function StatusBar({ sensorOrSubSensorInfo, activated = false, size = 'md' }: Readonly<Props>) {
  switch (size) {
    case 'lg':
      return activated ? (
        <Icon
          as={IcActivatedStatusBarHigh}
          height="60px"
          width="8px"
          color={sensorOrSubSensorInfo ? getSensorHexColor(sensorOrSubSensorInfo) : hexColor[ColorLabelEnum.GREEN]}
        />
      ) : (
        <Icon as={IcStatusBarHigh} height="60px" width="8px" />
      );
    case 'md':
    default:
      return activated ? <IcActivatedStatusBar height="36px" width="8px" /> : <IcStatusBar height="36px" width="8px" />;
  }
}
